export const modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { header: [3, 4, false] }],
    [{ font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['blockquote', 'code-block'],
    [{ align: [] }],
    ['link'],
    ['clean'],
  ],
};

export const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'blockquote',
  'code-block',
  'align',
  'link',
];

export const reviewStatus = [
  { className: 'pending', label: 'Pending' },
  { className: 'approved', label: 'Approved' },
  { className: 'rejected', label: 'Rejected' },
];
